import React from 'react';
import { ChatSession } from '../../hooks/useChatHistory';
import { MessageSquare, Trash2, Clock, X, RotateCcw } from 'lucide-react';
interface ChatHistorySidebarProps {
  sessions: ChatSession[];
  activeSessionId: string | null;
  currentSessionId: string;
  onSelectSession: (session: ChatSession) => void;
  onDeleteSession: (id: string) => void;
  onClearAll: () => void;
  onClose: () => void;
}
function formatDate(ts: number): string {
  const d = new Date(ts);
  const now = new Date();
  const diff = now.getTime() - d.getTime();
  if (diff < 60000) return 'ahora';
  if (diff < 3600000) return `hace ${Math.floor(diff / 60000)}m`;
  if (diff < 86400000) return `hace ${Math.floor(diff / 3600000)}h`;
  return d.toLocaleDateString('es', {
    day: 'numeric',
    month: 'short'
  });
}
export function ChatHistorySidebar({
  sessions,
  activeSessionId,
  currentSessionId,
  onSelectSession,
  onDeleteSession,
  onClearAll,
  onClose
}: ChatHistorySidebarProps) {
  const safeSessions = Array.isArray(sessions) ? sessions : [];
  return <div className="w-72 bg-slate-900 border-r border-slate-800 flex flex-col h-full animate-in slide-in-from-left-10 duration-300" data-id="element-3775">
      {/* Header */}
      <div className="p-4 border-b border-slate-800 flex items-center justify-between shrink-0" data-id="element-3776">
        <div className="flex items-center gap-2" data-id="element-3777">
          <MessageSquare size={16} className="text-indigo-400" data-id="element-3778" />
          <h3 className="text-sm font-semibold text-slate-200" data-id="element-3779">Historial</h3>
          <span className="text-[10px] bg-slate-800 text-slate-500 px-1.5 py-0.5 rounded-full" data-id="element-3780">
            {safeSessions.length}
          </span>
        </div>
        <button onClick={onClose} className="p-1 rounded-lg text-slate-500 hover:text-slate-300 hover:bg-slate-800 transition-colors" data-id="element-3781">
          <X size={16} data-id="element-3782" />
        </button>
      </div>

      {/* Sessions List */}
      <div className="flex-1 overflow-y-auto p-3 space-y-1" data-id="element-3783">
        {safeSessions.length === 0 ? <div className="text-center py-12 text-slate-600" data-id="element-3784">
            <MessageSquare size={32} className="mx-auto mb-3 opacity-30" data-id="element-3785" />
            <p className="text-sm" data-id="element-3786">Sin conversaciones guardadas</p>
            <p className="text-xs mt-1" data-id="element-3787">
              Las sesiones se guardan automáticamente
            </p>
          </div> : safeSessions.map(session => {
        const isActive = session.id === activeSessionId || session.id === currentSessionId;
        const sessionMessages = Array.isArray(session.messages) ? session.messages : [];
        const userMsgCount = sessionMessages.filter(m => m.role === 'user').length;
        return <div key={session.id} className={`group relative p-3 rounded-lg cursor-pointer transition-all ${isActive ? 'bg-indigo-900/30 border border-indigo-500/40' : 'hover:bg-slate-800 border border-transparent'}`} onClick={() => onSelectSession(session)} data-id="element-3788">
                <div className="flex items-start justify-between gap-2" data-id="element-3789">
                  <p className={`text-xs font-medium leading-snug flex-1 ${isActive ? 'text-indigo-300' : 'text-slate-300'}`} data-id="element-3790">
                    {session.title}
                  </p>
                  <button onClick={e => {
              e.stopPropagation();
              onDeleteSession(session.id);
            }} className="opacity-0 group-hover:opacity-100 p-0.5 text-slate-600 hover:text-red-400 transition-all shrink-0" data-id="element-3791">
                    <Trash2 size={12} data-id="element-3792" />
                  </button>
                </div>
                <div className="flex items-center gap-2 mt-1.5" data-id="element-3793">
                  <span className="flex items-center gap-1 text-[10px] text-slate-600" data-id="element-3794">
                    <Clock size={9} data-id="element-3795" /> {formatDate(session.updatedAt)}
                  </span>
                  <span className="text-[10px] text-slate-600" data-id="element-3796">·</span>
                  <span className="text-[10px] text-slate-600" data-id="element-3797">
                    {userMsgCount} mensajes
                  </span>
                </div>
              </div>;
      })}
      </div>

      {/* Footer */}
      {safeSessions.length > 0 && <div className="p-3 border-t border-slate-800 shrink-0" data-id="element-3798">
          <button onClick={onClearAll} className="w-full flex items-center justify-center gap-2 py-2 text-xs text-slate-500 hover:text-red-400 hover:bg-red-950/20 rounded-lg transition-all border border-transparent hover:border-red-900/30" data-id="element-3799">
            <RotateCcw size={12} data-id="element-3800" /> Limpiar historial
          </button>
        </div>}
    </div>;
}